<template>
  <div class="WTable">
    <el-table
      ref="tableTemplate"
      v-loadmore="loadMore"
      v-loading="tableLoading"
      :class="tableType === 'link' ? 'linkTable' : ''"
      :data="tableData"
      :stripe="tableType === 'myunfinishedTable' ? false : stripe"
      :border="border"
      :size="tableSize"
      :row-key="showToolBar ? 'rid' : ''"
      highlight-current-row
      :height="tableHeight"
      :max-height="maxHeight"
      @current-change="handleCurrentRowChange"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
      @row-contextmenu="contextmenu"
      @row-click="handleRowClick"
      @header-dragend="handleDragend"
      :row-class-name="tableRowClassName"
      :cell-style="tagColor"
      :row-style="
        tableType === 'decision' || tableType === 'dataList' ? rollStyle : {}
      "
      :header-row-style="headerStyle"
      :header-cell-style="headerStyle"
      style="width: 100%"
    >
      <el-table-column
        v-if="hasSelect"
        reserve-selection
        :selectable="handeleSelectable"
        type="selection"
        width="35"
        align="center"
      >
      </el-table-column>
      <el-table-column
        v-if="
          (showToolBar && hasPagination && hasSN) || tableType === 'decision'
        "
        type="index"
        :label="$t('table.SN')"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <div class="index">
            <span class="lock" v-show="scope.row.lockState"
              ><svg-icon style="width: 12px; height: 12px" icon-class="lock"
            /></span>
            <span
              class="index"
              v-show="!scope.row.lockState"
              :style="
                tableType === 'decision'
                  ? { 'line-height': textStyle.lineHeight }
                  : {}
              "
            >
              {{
                tableType === "decision" && !hasPagination
                  ? scope.$index + 1
                  : scope.$index +
                    1 +
                    (pageQuery.pageIndex - 1) * pageQuery.pageSize
              }}
            </span>
          </div>
        </template>
      </el-table-column>
      <template v-for="(column, index) in tableHeader">
        <el-table-column
          v-if="column.hide !== true"
          :sortable="sortable"
          :prop="column.normalizedId === 0 ? `f-${column.id}` : column.column"
          :label="
            column.id === 0 && tableType === 'report'
              ? $t('table.' + column.column)
              : column.name
          "
          :width="column.baseType !== 3 ? column.width : '100'"
          :min-width="column.baseType !== 3 ? columnWidth(column) : ''"
          :key="index"
          :label-class-name="
            tableType === 'decision'
              ? column.filterArr.length !== 0
                ? 'highlight'
                : ''
              : ''
          "
          :align="
            tableType === 'decision'
              ? textStyle.textAlign
              : column.baseType === 3
              ? 'right'
              : ''
          "
          header-align="left"
          :formatter="
            column.baseType === 4
              ? column.showDateTime
                ? showDateTime
                : hideDataTime
              : normal
          "
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="column.link && linkFieldList.indexOf(column.id) !== -1"
              @click.stop.prevent="
                $emit('handleLink', $event, column.id, scope.row)
              "
            >
              {{
                scope.row[
                  column.normalizedId === 0 ? `f-${column.id}` : column.column
                ]
              }}
            </el-button>
            <template v-else-if="column.baseType === 5">
              <el-badge
                type="primary"
                :hidden="!hasData(scope, column)"
                :value="
                  hasData(scope, column)
                    ? colConvert(scope, column).data.length
                    : 0
                "
                class="item"
              >
                <img
                  :title="
                    hasData(scope, column)
                      ? colConvert(scope, column).data[0].name
                      : '暂无图片'
                  "
                  class="vcenter"
                  :src="
                    hasData(scope, column)
                      ? colConvert(scope, column).data[0].thumbnail
                      : noImg
                  "
                  @click.stop.prevent="
                    handleImgPreview(
                      hasData(scope, column)
                        ? colConvert(scope, column).data
                        : [],
                      column.id
                    )
                  "
                />
              </el-badge>
            </template>
            <template v-else-if="column.baseType === 6">
              <el-badge
                type="primary"
                :hidden="!hasData(scope, column)"
                :value="
                  hasData(scope, column)
                    ? colConvert(scope, column).data.length
                    : 0
                "
              >
                <el-link
                  type="primary"
                  :underline="false"
                  @click.stop.prevent="
                    $emit(
                      'handleAttach',
                      hasData(scope, column)
                        ? colConvert(scope, column).data
                        : [],
                      scope.row.rid
                    )
                  "
                >
                  {{
                    hasData(scope, column)
                      ? colConvert(scope, column).data[0].name
                      : $t("table.noData")
                  }}
                </el-link>
              </el-badge>
            </template>
            <span v-else-if="templateConnectField.indexOf(column.id) >= 0">
              <el-button
                type="text"
                style="text-decoration: underline"
                @click.stop.prevent="
                  $emit('handleConnectClick', $event, column.id, scope.row)
                "
                >{{ formatFieldValue(scope.row, column) }}</el-button
              >
            </span>
            <span v-else-if="column.baseType === 1 && column.dataType === 107">
              <el-link
                type="primary"
                :underline="false"
                :href="
                  linkCellSplit(
                    scope.row[
                      column.normalizedId === 0
                        ? `f-${column.id}`
                        : column.column
                    ]
                  )[0]
                "
                target="_blank"
              >
                {{
                  linkCellSplit(
                    scope.row[
                      column.normalizedId === 0
                        ? `f-${column.id}`
                        : column.column
                    ]
                  )[1]
                }}
              </el-link>
            </span>
            <span v-else>
              {{ formatFieldValue(scope.row, column) }}
            </span>
          </template>
        </el-table-column>
      </template>
      <el-table-column
        v-if="showToolBar"
        fixed="right"
        :label="$t('table.toolBar')"
        align="center"
        ref="toolBar"
        class-name="toolBar"
        :width="toolBarWidth"
      >
        <!-- 宽度重新计算 -->
        <template slot-scope="scope">
          <div v-if="tableType === 'report'" ref="reportFixedColumn">
            <div>
              <el-button
                v-waves
                type="text"
                @click="handleCheck(scope.row, scope.$index)"
                v-if="mutableNames.find((m) => m.subId === '3').state"
              >
                {{
                  mutableNames.find((m) => m.subId === "3").value ||
                  $t("buttons.check")
                }}
                <el-divider
                  direction="vertical"
                  v-if="
                    ((permissions.modify > 0 || permissions.delete > 0) &&
                      mutableNamesLength > 1) ||
                    actionList.filter((action) => !action.batch).length
                  "
                ></el-divider>
              </el-button>
              <el-button
                v-waves
                type="text"
                v-if="permissions.modify > 0"
                @click="handleEdit(scope.row)"
                :disabled="scope.row.lockState || scope.row.reportStatus !== 1"
              >
                {{ mutableNames.find((m) => m.subId === "2").value }}
                <el-divider
                  direction="vertical"
                  v-if="
                    (permissions.delete > 0 && mutableNamesLength > 1) ||
                    actionList.filter((action) => !action.batch).length
                  "
                ></el-divider>
              </el-button>
              <el-button
                v-waves
                type="text"
                :key="action.id"
                v-for="(action, index) in actionList.filter(
                  (action) => !action.batch
                )"
                @click="$emit('handleAction', action.id, scope.row.rid)"
              >
                {{ action.style.alias }}
                <el-divider
                  direction="vertical"
                  v-if="
                    permissions.delete > 0 ||
                    index <
                      actionList.filter((action) => !action.batch).length - 1
                  "
                ></el-divider>
              </el-button>
              <el-button
                v-waves
                type="text"
                style="color: #f56c6c"
                v-if="permissions.delete > 0"
                @click="handleDelete(scope.row)"
                :disabled="scope.row.lockState || scope.row.reportStatus === 2"
              >
                {{ $t("buttons.delete") }}
              </el-button>
            </div>
          </div>
          <div v-else-if="tableType === 'todoTable'">
            <el-button
              v-waves
              type="text"
              @click="$emit('handleTransact', scope.row)"
            >
              {{ $t("buttons.handle") }}
            </el-button>
            <el-button
              :disabled="scope.row.type === 1"
              type="text"
              style="color: #f56c6c"
              @click="$emit('handleBack', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.rollBack") }}
            </el-button>
            <el-button
              v-waves
              type="text"
              @click="$emit('handleSchedule', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.schedule") }}
            </el-button>
          </div>
          <div v-else-if="tableType === 'unprocessedTable'">
            <el-button
              v-waves
              type="text"
              :disabled="scope.row.recordId <= 0"
              @click="$emit('handleCheck', scope.row)"
              >{{ $t("buttons.check") }}</el-button
            >
            <el-button
              v-waves
              type="text"
              @click="$emit('handleSchedule', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.schedule") }}
            </el-button>
            <el-button
              type="text"
              style="color: #f56c6c"
              @click="$emit('handleRevoke', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.reDo") }}
            </el-button>
          </div>
          <div v-else-if="tableType === 'myunfinishedTable'">
            <el-button
              v-waves
              type="text"
              :disabled="scope.row.recordId <= 0"
              @click="$emit('handleCheck', scope.row)"
              >{{ $t("buttons.check") }}</el-button
            >
            <el-button
              :disabled="!scope.row.isUrge"
              type="text"
              style="color: #f56c6c"
              @click.stop.prevent="$emit('handleUrge', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.urge") }}
            </el-button>
            <el-button
              v-waves
              type="text"
              @click="$emit('handleSchedule', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.schedule") }}
            </el-button>
          </div>
          <div v-else-if="tableType === 'unreadTable'">
            <el-button
              v-waves
              type="text"
              :loading="scope.row.loading"
              @click="$emit('handleRead', scope.row)"
              >{{ $t("workflow.read") }}</el-button
            >
            <el-button
              v-waves
              type="text"
              :disabled="scope.row.recordId <= 0"
              @click="$emit('handleCheck', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.check") }}
            </el-button>
            <el-button
              v-waves
              type="text"
              @click="$emit('handleSchedule', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.schedule") }}
            </el-button>
          </div>
          <div
            v-else-if="
              tableType === 'doneTable' ||
              tableType === 'finishedTable' ||
              tableType === 'processingTable' ||
              tableType === 'allTable' ||
              tableType === 'finished'
            "
          >
            <el-button
              v-waves
              type="text"
              :disabled="scope.row.recordId <= 0"
              @click="$emit('handleCheck', scope.row)"
              >{{ $t("buttons.check") }}</el-button
            >
            <el-button
              v-if="tableType === 'finished'"
              :disabled="scope.row.type === 1"
              type="text"
              style="color: #f56c6c"
              @click="$emit('handleResume', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.resume") }}
            </el-button>
            <el-button
              v-waves
              type="text"
              @click="$emit('handleSchedule', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.schedule") }}
            </el-button>
          </div>
          <div v-else-if="tableType === 'allWorkFlow'">
            <el-button
              v-waves
              type="text"
              :disabled="scope.row.recordId <= 0"
              @click="$emit('handleCheck', scope.row)"
              >{{ $t("buttons.check") }}</el-button
            >
            <el-button
              v-waves
              type="text"
              @click="$emit('handleSchedule', scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.schedule") }}
            </el-button>
            <el-button
              v-waves
              type="text"
              style="color: #f56c6c"
              @click="handleDelete(scope.row)"
            >
              <el-divider direction="vertical"></el-divider>
              {{ $t("buttons.delete") }}
            </el-button>
          </div>
          <div v-else-if="tableType === 'decision'">
            <el-button
              size="mini"
              v-waves
              type="primary"
              plain
              @click="$emit('handleDataListButton', scope.row)"
            >
              {{ buttonName }}
            </el-button>
          </div>
          <div v-else-if="tableType === 'dataList'">
            <el-button
              v-if="action === 2"
              v-waves
              type="primary"
              plain
              @click="$emit('handleDataListLink', scope.row)"
            >
              {{ $t("buttons.edit") }}
            </el-button>
            <el-button
              v-else-if="action === 3"
              v-waves
              type="primary"
              plain
              @click="$emit('handleDataListLink', scope.row)"
            >
              {{ $t("buttons.check") }}
            </el-button>
          </div>
        </template>
      </el-table-column>
      <div
        slot="append"
        v-if="tableType === 'decision'"
        style="text-align: center"
      >
        <el-button
          type="text"
          @click="loadMore"
          v-if="tableData.length < pageTotal && !hasPagination"
          >{{ $t("table.loadMore") }}</el-button
        >
        <!-- <el-button type="text" disabled v-else>没有更多了</el-button> -->
      </div>
    </el-table>
    <el-row class="pagination-row">
      <el-col :span="4">
        <slot name="batch">&nbsp;</slot>
      </el-col>
      <el-col :span="20">
        <el-pagination
          v-if="hasPagination"
          style="text-align: right"
          :style="
            tableType === 'decision'
              ? { background: textStyle.background, color: textStyle.color }
              : {}
          "
          :background="background"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageQuery.pageIndex"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="pageQuery.pageSize"
          :layout="layout"
          :total="pageTotal"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import noImg from '@/assets/images/noImg.svg'
import { parseTime } from '@/utils'
import {getSolutionId} from '@/utils/auth'
import { Decimal } from 'decimal.js'
export default {
  name: 'WTable',
  props: {
    background: {
      type: Boolean,
      default: true
    },
    layout: {
      type: String,
      default: 'total,jumper, prev, pager, next,sizes'
    },
    tableRowClassName: {
      type: Function,
      default: () => { }
    },
    stripeColor: '',
    textStyle: {},
    headerStyle: {},
    currentActivity: {
      type: Array,
      default() {
        return []
      }
    },
    mutableNames: {
      type: Array,
      default() {
        return [
          { subId: '1', value: '新增' },
          { subId: '2', value: '编辑' },
          { subId: '3', value: '查看' }
        ]
      }
    },
    action: {
      type: Number,
      default: 1
    },
    permissions: {
      type: Object,
      default() {
        return {}
      }
    },
    border: {
      type: Boolean,
      default: true
    },
    stripe: {
      type: Boolean,
      default: true
    },
    buttonName: {
      type: String,
      default: ''
    },
    sortable: {
      type: [Boolean, String],
      default: 'custom'
    },
    maxHeight: {
      type: String
    },
    tableSize: {
      type: String,
      default: 'small'
    },
    hasSN: {
      type: Boolean,
      default: true
    },
    hasPagination: {
      type: Boolean,
      default: true
    },
    linkFieldList: {
      type: Array,
      default() {
        return []
      }
    },
    hasSelect: {
      type: Boolean,
      default: false
    },
    tableType: {
      type: String,
      default: 'report'
    },
    showTag: false,
    defaultSort: undefined,
    tableHeight: {
      type: String,
      default: '45vh'
    },
    pageTotal: {
      type: Number,
      default: 0
    },
    pageQuery: {},
    showToolBar: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      required: true
    },
    tableHeader: undefined,
    tableLoading: {
      type: Boolean,
      default: false
    },
    actionList: {
      type: Array,
      default: () => []
    },
    templateConnectField: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      toolBarWidth: 120,
      noImg: noImg
    }
  },
  activated() {
    // 对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
    this.$refs.tableTemplate.doLayout()
  },
  watch: {
    tableData(newVal) {
      if (newVal.length) {
        this.getToolBarWidth()
      }
    },
    language() {
      this.getToolBarWidth()
    }
  },

  computed: {
    language() {
      return this.$store.getters.language
    },
    mutableNamesLength() {
      const subId = ['2', '3']
      const names = this.mutableNames.filter(m => subId.indexOf(m.subId) !== -1 && m.state)
      return names.length
    }
    // 操作栏宽度
    // toolBarWidth() {
    //   const width = {
    //     zh: {
    //       report: '180',
    //       todoTable: '160',
    //       allWorkFlow: '160',
    //       doneTable: '120',
    //       unprocessedTable: '160',
    //       unreadTable: '180',
    //       decision: '80'
    //     },
    //     en: {
    //       report: this.$route.params.type === '2' ? '270' : '240',
    //       todoTable: '270',
    //       allWorkFlow: '270',
    //       doneTable: '190',
    //       unreadTable: '270',
    //       unprocessedTable: '260'
    //     }
    //   }
    //   if (width[this.language][this.tableType]) {
    //     return width[this.language][this.tableType]
    //   } else {
    //     return '100'
    //   }
    // }
  },
  methods: {
    handleDragend(newWidth, oldWidth, column, event) {
      this.$emit('handleDragend', { newWidth, oldWidth, column, event })
    },
    colConvert(scope, column) {
      return scope.row[(this.tableType === 'decision' || this.tableType === 'dataList' || this.tableType === 'link') ? column.column : `f-${column.id}`]
    },
    hasData(scope, column) {
      return this.colConvert(scope, column) && this.colConvert(scope, column).data && this.colConvert(scope, column).data.length
    },
    handleGetFilter(column) {
      this.$emit('handleGetFilter', column)
    },
    filterHandler(filters, column) {
      this.$emit('filterHandler', filters, column)
    },
    rollStyle({ row, rowIndex }) {
      if (this.textStyle) {
        if ((rowIndex + 1) % 2 === 0) {
          const style = JSON.parse(JSON.stringify(this.textStyle))
          style.background = this.stripeColor ? this.stripeColor : style.background
          return style
        } else {
          return this.textStyle
        }
      } else {
        return {}
      }
    },
    getToolBarWidth() {
      this.$nextTick(() => {
        const td = this.$refs.tableTemplate.$el.querySelector('td.toolBar')
        if (!td) return
        const btns = td.querySelectorAll('.el-button')
        this.toolBarWidth = 30
        btns.forEach(b => {
          this.toolBarWidth += b.offsetWidth + 2
        })
        this.toolBarWidth = this.toolBarWidth === 32 ? 100 : this.toolBarWidth
      })
    },
    loadMore() {
      this.$emit('loadMore')
    },
    handleRowClick(row) {
      this.$emit('handleRowClick', row)
    },
    handleImgPreview(imgArr, id) {
      this.$emit('handleImgPreview', imgArr, id)
    },
    handleSelectionChange(row) {
      this.$emit('handleSelectionChange', row)
    },
    handeleSelectable(row) {
      if (this.tableType === 'todoTable') {
        if (this.currentActivity.length) {
          return this.currentActivity.indexOf(row.activityId) !== -1
        } else {
          return false
        }
      } else if (row.reportStatus && row.reportStatus === 2) {
        return false
      } else {
        return !row.lockState
      }
    },
    linkCellSplit(content) {
      if (content && content.indexOf('^^') >= 0) {
        return content.split('^^')
      } else {
        return [content, content]
      }
    },
    tagColor({ row, column, rowIndex, columnIndex }) {
      if (this.tableType === 'report' && this.showTag) {
        if (columnIndex === 0) {
          if (row.tag === 0 || row.tag === null) {
            return ''
          } else {
            return row.tag === 2 ? { 'background': '#e6a23c' } : { 'background': '#fdf6ec' }
          }
        }
      }
      // if (this.tableType === 'allWorkFlow') {
      //   if (columnIndex === 0) {
      //     if (row.status === 0 || row.status === null) {
      //       return { 'background': '#fdf6ec' }
      //     } else {
      //       return ''
      //     }
      //   }
      // }
      // const test = [
      //   {
      //     rid: 655,
      //     index: 5,
      //     style: {
      //       'background': '',
      //       'text-decoration': 'underline',
      //       'color': 'red',
      //       'font-weight': 'bold',
      //       'font-style': 'italic'
      //     }
      //   }
      // ]
      // const arr = test.filter(t => t.rid === row.rid)
      // const styleArr = arr.filter(a => a.index === columnIndex)
      // return styleArr.length ? styleArr[styleArr.length - 1].style : ''
    },
    // 右击
    contextmenu(row, column, e) {
      console.log(e)
      e.preventDefault()
      this.$emit('contextmenu', row, e)
    },
    // 查看
    handleCheck(row, index) {
      if (index !== undefined) {
        row.index = index
      }
      this.$emit('handleCheck', row)
    },
    // 编辑
    handleEdit(row) {
      this.$emit('handleEdit', row)
    },
    // 删除
    handleDelete(row) {
      this.$emit('handleDelete', row)
    },
    // 排序
    sortChange(val) {
      const prop = val.prop !== null ? val.prop.split('-')[1] || val.prop : null
      const sort = val.order !== null ? `${prop}|${val.order.substring(0, val.order.length - 6)}` : this.defaultSort
      this.$emit('sortChange', sort)
    },
    handleCurrentRowChange(val) {
      this.$emit('handleCurrentRowChange', val)
    },
    handleSizeChange(val) {
      this.pageQuery.pageSize = val
      this.$emit('handleSizeChange')
    },
    handleCurrentChange(val) {
      this.pageQuery.pageIndex = val
      this.$emit('handleCurrentChange')
    },
    columnWidth(row) {
      if (this.tableType === 'report') {
        const property = row.normalizedId === 0 ? `f-${row.id}` : row.column
        const tableWidth = localStorage.getItem('tableWidth')
          ? JSON.parse(localStorage.getItem('tableWidth'))
          : {}
        const tableId = this.tableHeader[0].owner
        const solution = getSolutionId()
        if (tableWidth[solution] && tableWidth[solution][tableId]) {
          if (tableWidth[solution][tableId][property]) {
            console.log(property)
            console.log(tableWidth[solution][tableId][property])
            return tableWidth[solution][tableId][property] + 'px'
          }
        }
      }
      // console.log(row)
      const sizeof = function (str, charset) {
        let total = 0
        let charCode
        let i
        let len
        charset = charset ? charset.toLowerCase() : ''
        if (charset === 'utf-16' || charset === 'utf16') {
          for (i = 0, len = str.length; i < len; i++) {
            charCode = str.charCodeAt(i)
            if (charCode <= 0xffff) {
              total += 2
            } else {
              total += 4
            }
          }
        } else {
          for (i = 0, len = str.length; i < len; i++) {
            charCode = str.charCodeAt(i)
            if (charCode <= 0x007f) {
              total += 1
            } else if (charCode <= 0x07ff) {
              total += 2
            } else if (charCode <= 0xffff) {
              total += 3
            } else {
              total += 4
            }
          }
        }
        return total
      }
      if (this.tableType === 'report' || this.tableType === 'decision') {
        if (row.id === undefined || row.id === 0) {
          if (row.baseType === 4) {
            return '120'
          } else {
            const column = this.tableData.map(t => {
              return t[row.column] ? sizeof(t[row.column], 'utf-8') : 0
            })
            column.sort(function (a, b) {
              return b - a
            })
            if (column[0]) {
              if ((column[0] * 4 + 22) < 110) {
                return 110
              } else if ((column[0] * 4 + 22) > 400) {
                return 400
              } else {
                return (column[0] * 4 + 22).toString()
              }
            } else {
              return '120'
            }
            // return column[0] ? (column[0] * 4 + 22).toString() : '120'
          }
        } else {
          if (row.baseType === 4) {
            return '120'
          } else {
            const column = this.tableData.map(t => {
              return t['f-' + row.id] ? sizeof(t['f-' + row.id], 'utf-8') : 0
            })
            column.sort(function (a, b) {
              return b - a
            })
            if (column[0]) {
              if ((column[0] * 4 + 22) < 110) {
                return 110
              } else if ((column[0] * 4 + 22) > 400) {
                return 400
              } else {
                return (column[0] * 4 + 22).toString()
              }
            } else {
              return '120'
            }
            // return column[0] ? ((column[0] * 4 + 22) < 110 ? 110 : (column[0] * 4 + 22)).toString() : '120'
          }
        }
      } else {
        return ''
      }
    },
    showDateTime(cellValue) {
      if (cellValue !== null) {
        return cellValue === '1900/01/01 00:00' ? '' : parseTime(new Date(cellValue), '{y}-{m}-{d} {h}:{i}')
      } else {
        return cellValue
      }
    },
    hideDataTime(cellValue) {
      if (cellValue !== null) {
        return cellValue === '1900/01/01 00:00' ? '' : parseTime(new Date(cellValue), '{y}-{m}-{d}')
      } else {
        return cellValue
      }
    },
    normal(cellValue) {
      return cellValue === '1900/01/01 00:00' ? '' : cellValue
    },
    dateFormat(date, fmt) {
      var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    },
    formatFieldValue(row, columnInfo) {
      var rowData = row[columnInfo.normalizedId === 0 ? `f-${columnInfo.id}` : columnInfo.column]
      if (!rowData) {
        if (columnInfo.baseType === 3) {
          rowData = 0
        } else {
          return ''
        }
      }
      try {
        switch (columnInfo.baseType) {
          case 3:
            var length = columnInfo.dispScale === 0 ? 0 : (columnInfo.dispScale || 0)
            rowData = new Decimal(rowData)
            switch (columnInfo.dataType) {
              case 301:
                // 整数
                return rowData.truncated().toNumber()
              case 302:
                // 小数
                return this.numberCover(rowData.toDP(length).toNumber(), length)
              // case 303:
              //   // 数值去尾
              //   return rowData.toNumber()
              case 304:
                // 百分比小数
                return this.numberCover(rowData.times(100).toDP(length).toNumber(), length) + '%'
              // case 305:
              //   // 无限小数百分比
              //   return rowData.times(100).toDP(8).toNumber() + '%'
              case 306:
                // 人民币金额
                return '￥' + this.numberCover(rowData.toDP(length).toNumber(), length)
              case 307:
                // 美元金额
                return '$' + this.numberCover(rowData.toDP(length).toNumber(), length)
              case 308:
                return this.numberCover(this.numberThousands(rowData.toDP(length).toNumber()), length)
              default:
                // 数值去尾
                return this.numberCover(rowData.toNumber(), length)
            }
          case 4:
            try {
              if (rowData === '1900/01/01 00:00') {
                return ''
              }
              var dateTime = new Date(rowData)
              switch (columnInfo.dataType) {
                case 401:
                  // 2019
                  return this.dateFormat(dateTime, 'yyyy')
                case 402:
                  // 2019年
                  return this.dateFormat(dateTime, 'yyyy年')
                case 403:
                  // 2019-1
                  return this.dateFormat(dateTime, 'yyyy-M')
                case 421:
                  // 2019-1
                  return this.dateFormat(dateTime, 'yyyy-MM')
                case 404:
                  // 2019/1
                  return this.dateFormat(dateTime, 'yyyy/M')
                case 422:
                  // 2019/1
                  return this.dateFormat(dateTime, 'yyyy/MM')
                case 405:
                  // 2019年1月
                  return this.dateFormat(dateTime, 'yyyy年M月')
                case 423:
                  // 2019年1月
                  return this.dateFormat(dateTime, 'yyyy年MM月')
                case 412:
                  // 1月
                  return this.dateFormat(dateTime, 'M月')
                case 406:
                  // 2019-1-1
                  return this.dateFormat(dateTime, 'yyyy-M-d')
                case 424:
                  // 2019-1-1
                  return this.dateFormat(dateTime, 'yyyy-MM-dd')
                case 407:
                  // 2019/1/1
                  return this.dateFormat(dateTime, 'yyyy/M/d')
                case 425:
                  // 2019/1/1
                  return this.dateFormat(dateTime, 'yyyy/MM/dd')
                case 408:
                  // 2019年1月1日
                  return this.dateFormat(dateTime, 'yyyy年M月d日')
                case 426:
                  // 2019年1月1日
                  return this.dateFormat(dateTime, 'yyyy年MM月dd日')
                case 413:
                  // 1-1
                  return this.dateFormat(dateTime, 'M-d')
                case 427:
                  // 1-1
                  return this.dateFormat(dateTime, 'MM-dd')
                case 414:
                  // 1/1
                  return this.dateFormat(dateTime, 'M/d')
                case 428:
                  // 1/1
                  return this.dateFormat(dateTime, 'MM/dd')
                case 415:
                  // 1月1日
                  return this.dateFormat(dateTime, 'M月d日')
                case 429:
                  // 1月1日
                  return this.dateFormat(dateTime, 'MM月dd日')
                case 409:
                  // 2019-1-1 1:01:01
                  return this.dateFormat(dateTime, 'yyyy-M-d h:mm:ss')
                case 430:
                  // 2019-1-1 1:01:01
                  return this.dateFormat(dateTime, 'yyyy-MM-dd h:mm:ss')
                case 410:
                  // 2019/1/1 1:01:01
                  return this.dateFormat(dateTime, 'yyyy/M/d h:mm:ss')
                case 431:
                  // 2019/1/1 1:01:01
                  return this.dateFormat(dateTime, 'yyyy/MM/dd h:mm:ss')
                case 411:
                  // 2019年1月1日 1时01分01秒
                  return this.dateFormat(dateTime, 'yyyy年M月d日 h时mm分ss秒')
                case 432:
                  // 2019年1月1日 1时01分01秒
                  return this.dateFormat(dateTime, 'yyyy年MM月dd日 h时mm分ss秒')
                case 416:
                  // 1:01
                  return this.dateFormat(dateTime, 'h:mm')
                case 417:
                  // 1时01分
                  return this.dateFormat(dateTime, 'h时mm分')
                case 418:
                  // 1:01:01
                  return this.dateFormat(dateTime, 'h:mm:ss')
                case 419:
                  // 1时01分01秒
                  return this.dateFormat(dateTime, 'h时mm分ss秒')
                case 433:
                  return this.dateFormat(dateTime, 'yyyy-m-d h:mm')
                case 434:
                  return this.dateFormat(dateTime, 'yyyy-mm-dd h:mm')
                case 435:
                  return this.dateFormat(dateTime, 'yyyy/m/d h:mm')
                case 436:
                  return this.dateFormat(dateTime, 'yyyy/mm/dd h:mm')
                case 437:
                  return this.dateFormat(dateTime, 'yyyy"年"m"月"d"日" h时mm分')
                case 438:
                  return this.dateFormat(dateTime, 'yyyy"年"mm"月"dd"日" h时mm分')
                default:
                  if (dateTime.getHours() + dateTime.getMinutes() + dateTime.getSeconds()) {
                    return this.dateFormat(dateTime, 'yyyy-M-d h:mm:ss')
                  } else {
                    return this.dateFormat(dateTime, 'yyyy-M-d')
                  }
              }
            } catch (ex) {
              return rowData
            }
          case 1:
          case 5:
          case 6:
          default:
            return rowData
        }
      } catch (exp) {
        console.log(exp)
        console.error('转换失败！')
        return rowData
      }
    },
    numberThousands(number) {
      if (number) {
        var str = number.toString()
        var leftSide = str
        var hasDecimal = false
        if (str.indexOf('.') >= 0) {
          leftSide = str.split('.')[0]
          hasDecimal = true
        }
        var length = leftSide.length
        for (var i = 0; i < length; i++) {
          if ((i + 1) % 3 === 0 && length - i - 1 > 0) {
            leftSide = leftSide.slice(0, length - i - 1) + ',' + leftSide.slice(length - i - 1)
          }
        }
        if (hasDecimal) {
          return leftSide + '.' + str.split('.')[1]
        } else {
          return leftSide
        }
      } else {
        return str
      }
    },
    numberCover(number, length) {
      if (length > 0) {
        number = (number || 0).toString()
        const splitEle = number.split('.')
        if (splitEle.length === 1) {
          splitEle.push('')
        }
        splitEle[1] += '0'.repeat(length)
        return splitEle[0] + '.' + splitEle[1].substring(0, length)
      } else {
        return (number || 0).toString()
      }
    },
    handleConnectClick(e, fieldId, row) {
      this.$emit('handleConnectClick', fieldId, row, e)
    }
  }
}
</script>
<style lang="scss">
.el-popper.table-filter {
  border: 1px solid #ebeef5;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin: 2px 0;
  padding: 0;
  .el-table-filter__bottom {
    border-top: 1px solid #ebeef5;
    padding: 8px;
    button {
      background: transparent;
      border: none;
      color: #606266;
      cursor: pointer;
      font-size: 13px;
      padding: 0 3px;
    }
    button.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}
.WTable {
  .el-table__row:hover .lock {
    display: none !important;
  }
  .el-table__row:hover .index {
    display: block !important;
  }
  .el-table__fixed-right {
    right: 8px !important;
  }
  a.el-link {
    display: block;
  }
  .el-button.is-disabled {
    color: #c0c4cc !important;
  }
  .el-button + .el-button {
    margin-left: 0;
  }
  .el-divider--vertical {
    // margin:0 2px;
    margin-top: -1px;
  }
  .el-badge {
    &.item {
      display: block;
      text-align: center;
      width: 48px;
      height: 100%;
      margin: 0 auto;
      cursor: pointer;
      position: relative;
    }
    .el-badge__content {
      top: 16px;
      right: 0px;
    }
  }
  .el-checkbox {
    float: left;
  }
  .el-table th > .cell {
    white-space: nowrap;
    overflow: hidden;
    height: 23px !important;
    line-height: 23px !important;
  }
  .linkTable .cell {
    height: 32px !important;
    line-height: 32px !important;
  }
  .el-table .caret-wrapper {
    position: absolute;
    right: 0px;
    background: #fff;
    top: 50%;
    margin-top: -17px;
  }
  .el-pagination__jump {
    margin: 0 12px;
  }
  .pagination-row {
    margin-top: 0 !important;
    padding-top: 10px;
    padding-bottom: 5px;
    border: 1px solid #ebeef5;
    border-top: none;
  }
  .badge {
    position: absolute;
    top: 50%;
    border-radius: 50%;
    margin-top: -5px;
    width: 10px;
    height: 10px;
    z-index: 99;
    left: 50%;
    margin-left: -5px;
    background-color: #409eff;
  }
}
</style>
